export default __webpack_public_path__ + "static/media/i250sp.dd0771d8.webp";